export const PrimaryColor = '#A7893D';
